// core/services/notification.service.ts
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private queue: { message: string; type: 'success' | 'error' | 'info' }[] = [];
  private isShowing = false;
  private duration = 3000;

  constructor(private snackBar: MatSnackBar, private translate: TranslateService) {}

  private showNext() {
    if (this.queue.length === 0 || this.isShowing) return;

    const { message, type } = this.queue.shift()!;
    this.isShowing = true;

    const closeLabel = this.translate.instant('common.closeSnack');

    const isMobile = this.isMobile();

    const ref = this.snackBar.open(message, closeLabel, {
      duration: this.duration,
      panelClass: [`snackbar-${type}`],
      horizontalPosition: isMobile ? 'center' : 'center',
      verticalPosition: isMobile ? 'bottom' : 'bottom'
    });

    ref.afterDismissed().subscribe(() => {
      this.isShowing = false;
      this.showNext();
    });
  }


  private enqueue(message: string, type: 'success' | 'error' | 'info') {
    this.queue.push({ message, type });
    this.showNext();
  }

  success(message: string) {
    this.enqueue(message, 'success');
  }

  error(message: string) {
    this.enqueue(message, 'error');
  }

  info(message: string) {
    this.enqueue(message, 'info');
  }

    private isMobile(): boolean {
    return window.innerWidth <= 1024; // or any breakpoint you define as "mobile"
  }

}


